var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.clientServices.length != _vm.dynamicClientServicesCountDisplay ||
      (_vm.clientServices.length == _vm.dynamicClientServicesCountDisplay &&
        _vm.loadFromDymamicServices)
  )?_c('div',{class:{ 'latest-file-cards': true, vertical: _vm.loadFromDymamicServices }},[_c('latest-file-card-item',{attrs:{"file":_vm.latestEligibilityFile,"fileText":"Eligibilty Data"}}),_vm._v(" "),_c('latest-file-card-item',{attrs:{"file":_vm.latestIncentiveFile,"fileText":"Incentive Points"}}),_vm._v(" "),_c('latest-file-card-item',{attrs:{"file":_vm.latestBiometricFile,"fileText":"Biometrics Points"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aea375bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/LatestFileCards.vue
// module id = 1607
// module chunks = 181